
export interface Role {
  roleName: string;
  roleID: string;
}

/**
 * @ interface State model declaration for store User role related fields
 **/

export interface UserRoles {
  email_address: string;
  roles: Array<Role> ;
  userType: string;
}

/**
 * @ class State model declaration for store User role related fields
 **/
export interface UserRoleState {
  updateRole: string;
  userRoles: UserRoles;
  roleList: Array<Role>;
}
/**
 * @ class Initial State model for user role store
 **/
export const initialUserRoleState: UserRoleState = {
  updateRole: null,
  userRoles: null,
  roleList: null,
};
